module.exports = function ToughCookie() {
    throw new TypeError('Cookie jars are only available on node');
};
//# sourceMappingURL=tough-cookie.js.map